"use client"

import { useState, useEffect } from "react"
import { gtagSendEvent } from "../../utils/gtaghelper"
import { motion, AnimatePresence } from "framer-motion"
import { PhoneCall, Zap, ShieldCheck, Rocket, Clock } from "lucide-react"
import "./contactpop.css"

const COUNTDOWN_DURATION = 300 // 5 minutes
const DEFAULT_PRICE = "699"

const OFFER_CODES = {
  EARLY: 349,
  SPECIAL: 399,
  DEFAULT: "499",
  PREMIUM: "999",
  SINGLE: 249,
  NEW: "499",
}

const formatPrice = (value) =>
  value.toLocaleString("en-CA")

const ContactPopup = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [seconds, setSeconds] = useState(COUNTDOWN_DURATION)
  const [price, setPrice] = useState(DEFAULT_PRICE)
  const [offerApplied, setOfferApplied] = useState(null)

  // 🎯 Apply offer from URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const offer = params.get("offer")?.toUpperCase()

    if (offer && OFFER_CODES[offer]) {
      setPrice(OFFER_CODES[offer])
      setOfferApplied(offer)
    }
  }, [])

  // 📱 Open popup after delay (mobile only)
  useEffect(() => {
    if (window.innerWidth <= 768) {
      const timer = setTimeout(() => {
        setSeconds(COUNTDOWN_DURATION) // reset timer on open
        setIsOpen(true)
      }, 6000)

      return () => clearTimeout(timer)
    }
  }, [])

  // ⏱ Countdown tick
  useEffect(() => {
    if (!isOpen || seconds <= 0) return

    const interval = setInterval(() => {
      setSeconds((prev) => Math.max(prev - 1, 0))
    }, 1000)

    return () => clearInterval(interval)
  }, [isOpen, seconds])

  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="popup-content funky"
            initial={{ scale: 0.85, y: 60, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.9, y: 40, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
          >
            <button className="popup-close" onClick={() => setIsOpen(false)}>
              ✕
            </button>

            <div className="offer-badge">
              <Zap size={14} />
              {offerApplied ? `${offerApplied} OFFER` : "LIMITED TIME OFFER"}
            </div>

            <div className="popup-icon pulse">
              <Rocket size={22} />
            </div>

            <h3 className="popup-title">
  Planning a New Website? <br />
  Starts at <span>${formatPrice(price)} CAD</span>
</h3>


            <p className="popup-subtitle">
              High-conversion websites for startups & businesses
            </p>

            <div className="countdown">
              <Clock size={14} />
              Offer ends in{" "}
              <strong>
                {mins}:{secs.toString().padStart(2, "0")}
              </strong>
            </div>

            <div className="popup-features-inline">
              <div className="feature-inline">
                <Zap size={18} />
                <span>Website Live in 48 hrs</span>
              </div>
              <div className="feature-inline">
                <ShieldCheck size={18} />
                <span>Pay After Development*</span>
              </div>
              <div className="feature-inline">
                <Rocket size={18} />
                <span>SEO + Mobile Optimized</span>
              </div>
            </div>

<a
  href="tel:+916363053425"
  className="call-now-btn crazy"
  onClick={() => {
    gtagSendEvent(
      "conversion_event_contact",
    )
  }}
>
              <PhoneCall size={18} />
              <span>Talk to an Expert (Free)</span>


              <span className="shine"></span>
            </a>

            <p className="popup-footnote">*T & C apply</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default ContactPopup
